/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BranchType } from '../models/BranchType';
import type { CapHpiDvlaDTO } from '../models/CapHpiDvlaDTO';
import type { CarConditionDescriptionDto } from '../models/CarConditionDescriptionDto';
import type { ValueCarDTO } from '../models/ValueCarDTO';
import type { ValueCarSaleType } from '../models/ValueCarSaleType';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ValueCarService {

  /**
   * @param id 
   * @returns ValueCarDTO Success
   * @throws ApiError
   */
  public static getValueCar(
id?: number,
): CancelablePromise<ValueCarDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ValueCar',
      query: {
        'id': id,
      },
    });
  }

  /**
   * @param formData 
   * @returns any Created
   * @throws ApiError
   */
  public static postValueCarCreateValueCar(
formData?: {
Name: string;
Lastname: string;
Email: string;
Phone: string;
Regnumber: string;
ServiceHistoryId: number;
Mileage: number;
Branch?: BranchType;
Additional?: string;
Vin?: string;
Model?: string;
Manufacturer?: string;
FuelType?: string;
Owners?: number;
Doors?: number;
Seating?: number;
DateFirstReg?: string;
BodyType?: string;
Color?: string;
CapId?: number;
Range?: string;
Transmission?: string;
LastServiceDate?: string;
Attempt?: string;
Derivative?: string;
DescriptionIds: Array<number>;
ValueCarSaleType: ValueCarSaleType;
MotDateId?: number;
TwoSetsOfKeys?: boolean;
LastSrvDateId?: number;
FileFront?: Blob;
FileDriverSide?: Blob;
FilePassangerSide?: Blob;
FileRear?: Blob;
FileDashboard?: Blob;
FileInteriorFront?: Blob;
FileInteriorRear?: Blob;
FileTireCondition?: Blob;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ValueCar/CreateValueCar',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * Get vehicle info by reg number
   * @param regNo Reg Number
   * @param vin Vin Number
   * @returns CapHpiDvlaDTO Success
   * @throws ApiError
   */
  public static getValueCarLookUpVehicle(
regNo?: string,
vin?: string,
): CancelablePromise<CapHpiDvlaDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ValueCar/LookUpVehicle',
      query: {
        'regNo': regNo,
        'vin': vin,
      },
    });
  }

  /**
   * @returns CarConditionDescriptionDto Success
   * @throws ApiError
   */
  public static getValueCarGetConditionDescriptions(): CancelablePromise<Array<CarConditionDescriptionDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ValueCar/GetConditionDescriptions',
    });
  }

  /**
   * @param regNo 
   * @param mileage 
   * @param descriptionIds 
   * @returns number Success
   * @throws ApiError
   */
  public static getValueCarGetVehicleAveragePrice(
regNo?: string,
mileage?: number,
descriptionIds?: Array<number>,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ValueCar/GetVehicleAveragePrice',
      query: {
        'regNo': regNo,
        'mileage': mileage,
        'descriptionIds': descriptionIds,
      },
    });
  }

  /**
   * @param valueCarId 
   * @param saleTypeId 
   * @returns any Success
   * @throws ApiError
   */
  public static patchValueCarUpdateValueCarSaleType(
valueCarId?: number,
saleTypeId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/ValueCar/UpdateValueCarSaleType',
      query: {
        'valueCarId': valueCarId,
        'saleTypeId': saleTypeId,
      },
      errors: {
        500: `Server Error`,
      },
    });
  }

}
